"use client";

import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { BarChart3 } from "lucide-react";

interface AnalyticsButtonProps {
  userId: string;
  variant?: "default" | "table";
}

export function AnalyticsButton({
  userId,
  variant = "default",
}: AnalyticsButtonProps) {
  const handleClick = () =>
    window.open(
      `https://dashboard.openpanel.dev/masterkey/masterkey-web/profiles/${userId}`,
      "_blank",
      "noopener,noreferrer",
    );

  if (variant === "table") {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant="ghost"
              size="icon"
              className="text-blue-600 hover:text-blue-700"
              onClick={handleClick}
            >
              <BarChart3 className="h-4 w-4" />
              <span className="sr-only">View Analytics</span>
            </Button>
          </TooltipTrigger>
          <TooltipContent>
            <p>View Analytics</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  return (
    <Button
      variant="outline"
      size="sm"
      className="flex items-center gap-2"
      onClick={handleClick}
    >
      <BarChart3 className="h-4 w-4" />
      Analytics
    </Button>
  );
}
